// {{WORKTREE_ROOT}}/picosponsorconsole/app/utils/pageTitle.ts
// PLAN3 C-3 — WCAG 2.4.2: one `meta` per page route, titled from a locale id of the page's own heading (never typed
// English, K-09). The root loader ships the language's strings, so the title follows the viewer's language. A missing id
// yields "" rather than throwing, and test/guards/route-titles.test.ts fails on it.
import type { MetaFunction } from "@remix-run/node";

type RootData = { locale?: { strings: Record<string, Record<string, string>> } } | undefined;

export function pageTitle(section: string, id: string): MetaFunction {
  return ({ matches }) => {
    const root = matches.find((m) => m.id === "root")?.data as RootData;
    return [{ title: root?.locale?.strings[section]?.[id] ?? "" }];
  };
}
